export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '5c690f0f-7860-4400-87d1-29fe18f86658',
      authority: 'https://login.microsoftonline.com/e0aadfc7-8ad3-4b7b-b063-42bfea6a739d',
    },
    uri: 'api://5c690f0f-7860-4400-87d1-29fe18f86658/.default',
  },
  apiConfig: {
    scopes: ['api://SecretManagerScope/LogIn'],
    uri: 'https://api.dev.sm.assetworks.com/secretmgr-app',
    ssoUri: 'https://api.dev.sm.assetworks.com/secretmgr-app-sso',
  },
  'Ocp-Apim-Subscription-Key': 'a81c27eb4b18416e911ca79243d2ed99',
  singleSignOnConfig: {
    loginCallbackUrl: 'https://app.dev.sm.assetworks.com/login/',
    logoutCallbackUrl: 'https://app.dev.sm.assetworks.com/logout/',
    cookieDomain: '.dev.sm.assetworks.com',
  },
};
